module.exports = __webpack_public_path__ + "static/media/logoBlack.b1eb02ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/images/logoBlack.svg
// module id = 992
// module chunks = 0